var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFever(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.1 94.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3e80;}.cls-2{fill:#5aad31;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.72,49.47c-.72,0-1.3-.58-1.3-1.3V19.78c0-.72,.58-1.3,1.3-1.3s1.3,.58,1.3,1.3v28.39c0,.72-.58,1.3-1.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.84,35.07c-.62,0-1.2-.38-1.42-.99-.29-.78,.12-1.65,.9-1.93l12.47-4.54c.79-.29,1.65,.12,1.93,.9,.29,.78-.12,1.65-.9,1.93l-12.47,4.54c-.17,.06-.35,.09-.52,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.65,35.07c-.17,0-.35-.03-.52-.09l-12.47-4.54c-.78-.28-1.19-1.15-.9-1.93,.28-.78,1.15-1.19,1.93-.9l12.47,4.54c.78,.28,1.19,1.15,.9,1.93-.22,.61-.8,.99-1.42,.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.1,43.31c0,2.24-1.81,4.05-4.05,4.05s-4.05-1.81-4.05-4.05,1.81-4.05,4.05-4.05,4.05,1.81,4.05,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.34,43.31c0,2.24,1.81,4.05,4.05,4.05s4.05-1.81,4.05-4.05-1.81-4.05-4.05-4.05-4.05,1.81-4.05,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.84,35.07c-.62,0-1.2-.38-1.42-.99-.29-.78,.12-1.65,.9-1.93l12.47-4.54c.79-.29,1.65,.12,1.93,.9,.29,.78-.12,1.65-.9,1.93l-12.47,4.54c-.17,.06-.35,.09-.52,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.65,35.07c-.17,0-.35-.03-.52-.09l-12.47-4.54c-.78-.28-1.19-1.15-.9-1.93,.28-.78,1.15-1.19,1.93-.9l12.47,4.54c.78,.28,1.19,1.15,.9,1.93-.22,.61-.8,.99-1.42,.99Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.45,54.14c-2.14-2.14-5.61-2.14-7.74,0l-14.4,14.4h-4.54l-.32,.03c-.82,.15-1.44,.86-1.44,1.73,0,.97,.79,1.75,1.75,1.75h15.94l.3-.06,.22-.07,.21-.1,.22-.15,.15-.13,9.65-9.65,.38-.42c1.75-2.15,1.63-5.32-.38-7.33Zm-2.48,5.26l-3.25,3.26c-.09-.23-.22-.45-.4-.63-.69-.69-1.8-.69-2.48,0l-6.5,6.5h-2.06l11.92-11.91,.27-.23c.77-.53,1.83-.46,2.51,.23,.77,.77,.77,2.01,0,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.05,94.1C21.11,94.1,0,72.99,0,47.05S21.11,0,47.05,0s47.05,21.11,47.05,47.05-21.11,47.05-47.05,47.05Zm0-90.72C22.97,3.38,3.38,22.97,3.38,47.05s19.59,43.67,43.67,43.67,43.67-19.59,43.67-43.67S71.13,3.38,47.05,3.38Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFever);
export default __webpack_public_path__ + "static/media/Fever.f0dbe0f3a7c6366e83998a070c608767.svg";
export { ForwardRef as ReactComponent };